module.exports = __webpack_public_path__ + "46c4dadfd1e0021caf234f002ba4275b.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_4.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_4.png
// module chunks = 40